import { useRoutes } from 'react-router-dom';
import './App.css';
import router from "./router"
import { useEffect, useState } from 'react';
function App() {
  const outlet = useRoutes(router);
  const [cssZoom, setCssZoom] = useState(1)

  useEffect(() => {
    calculateCssZoom();
    window.addEventListener('resize', calculateCssZoom);
    return () => {
      window.removeEventListener('resize', calculateCssZoom);
    };
  }, []);
  const calculateCssZoom = () => {
    const viewportWidth: number = document.documentElement.clientWidth || document.body.clientWidth; // 实际浏览器视口的宽度
    const designWidth: number = window['layoutWith']; // 设计稿的宽度
    const zoomValueWidth = viewportWidth / designWidth; // 宽度计算出来的zoom值
    const targetZoom = zoomValueWidth; // 比较大小选择最终实际需要的zoom值
    setCssZoom(targetZoom)
  };
  return (
    // style={{ zoom: cssZoom }}
    <div className="App">
      {outlet}
    </div>
  );
}

export default App;
